<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.logId === undefined" :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <!--
            <QDateTimeField v-model="start" :label="'after'"></QDateTimeField>
            <QDateTimeField v-model="end" :label="'before'"></QDateTimeField>
             -->
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getUnitLogListFromFilter" :optional-filters="filters"
          :locked-filters="{ UnitIdList: [unitId] }" :paginationEnabled="true" :show-filter-tab="false"
          :show-sorting-tab="false" :itemsPerPage="100" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item">
            </ListItem>
          </template>
        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/MachineLogListItem.vue";

export default {
  name: "ViewUnitLogList",
  props: {},
  components: {
    FilterPane,
    ListPane,
    Layout,
    ListItem,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "MLL-",
    };
  },

  mounted() { },

  methods: {},

  computed: {
    unitId() { return this.$route.params.unitId; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>